import { type ParentProps, lazy } from 'solid-js'
import { Grid } from 'styled-system/jsx'
import Header from './Header'
import ScheduledEventNotifications from './ScheduledEventNotifications'

const AddNew = lazy(() => import('./AddNew'))
const UserManagement = lazy(() => import('./UserManagement'))

function Container(props: ParentProps) {
  return <Grid gap='0' p='3' gridTemplateRows='auto 1fr'>
    <Header />
    {props.children}
  </Grid>
}

const routes = [
  {
    path: '/admin',
    component: Container,
    children: [
      {
        path: '/',
        component: UserManagement,
      },
      {
        path: '/add-new',
        component: AddNew,
      },
      {
        path: '/events',
        component: ScheduledEventNotifications,
      },
    ],
  },
]

export default routes
